import { okrDetailConstants } from '../constants/okr/okrDetails.constants';
export const isProgressFilterUsed = (progressFilter) => {
    if (progressFilter && progressFilter != '') {
        let progressList = progressFilter.split(",").filter(a => a != 0).sort(function (a,b) { return b-a }).join(',');
        if (progressList != okrDetailConstants.FILTER_PROGRESS_DEFAULT) {
            return true;
        }
    }    
	return false;				
}

